// @ vendors
const { Promise } = require('es6-promise');

// @ utilities
const { recordProcess, PROC_END, PROC_FAIL } = require('utilities/tagging');

// @ track processes
const { PROC_ADD_PROPERTY_VALUE, PROC_ADD_PROPERTY_CERT } = require('constants/mortgageRequestProcesses');

// @ commons
const { APIPost } = require('utilities/APIRequestHelper');

//@constants
const actionTypes = require('constants/actionTypes');
const { TAS_CLI, TAS_CERT } = require('constants/mortgageRequestDocumentsTypes');
const PAYMENT_TYPE = 'N'; // Cargo en cuenta

const requestUploadInProgress = () => ({
    type: actionTypes.MORTGAGE_REQUEST_PROPERTY_VALUE_UPLOAD_REQUEST
});

const requestUploadSuccess = data => ({
    type: actionTypes.MORTGAGE_REQUEST_PROPERTY_VALUE_UPLOAD_SUCCESS,
    data: data
});

const requestUploadFailure = error => ({
    type: actionTypes.MORTGAGE_REQUEST_PROPERTY_VALUE_UPLOAD_FAILURE,
    data: {
        error
    }
});

const requestUploadCertInProgress = () => ({
    type: actionTypes.MORTGAGE_REQUEST_PROPERTY_VALUE_CERT_UPLOAD_REQUEST
});

const requestUploadCertSuccess = data => ({
    type: actionTypes.MORTGAGE_REQUEST_PROPERTY_VALUE_CERT_UPLOAD_SUCCESS,
    data: data
});

const requestUploadCertFailure = error => ({
    type: actionTypes.MORTGAGE_REQUEST_PROPERTY_VALUE_CERT_UPLOAD_FAILURE,
    data: {
        error
    }
});

const resetView = error => ({
    type: actionTypes.MORTGAGE_REQUEST_PROPERTY_VALUE_RESET_VIEW,
    data: {
        error
    }
});

const appraisalPaymentFailure = error => ({
    type: actionTypes.MORTGAGE_REQUEST_PROPERTY_VALUE_PAYMENT_FAILURE,
    data: {
        error
    }
})

const appraisalPaymentSave = (uploadResponse, documentType) => dispatch => {
    const endpoint = 'mortgageRequestAppraisalPayment';
    const params = {
        query: {
            paymentType: PAYMENT_TYPE
        }
    }

    return APIPost({
        dispatch,
        endpoint,
        params
    })
        .then(() => {
            if (documentType === TAS_CLI) {
                dispatch(requestUploadSuccess(uploadResponse));
            } else if (documentType === TAS_CERT) {
                dispatch(requestUploadCertSuccess(uploadResponse));
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(appraisalPaymentFailure(response.error));
            } else {
                throw response;
            }
        })
}

const updateDocuments = sendResponse => (dispatch, getState) => {
    const currentState = getState().mortgageRequestPropertyValue;
    const isAlreadyFetching = currentState.get('isFetching');
    const idExpediente = getState().mortgageRequestState.get('idExpediente');

    if (!isAlreadyFetching) {
        dispatch(requestUploadInProgress());

        const fileObject = currentState.getIn(['files', 'fileTasacion']);

        if (fileObject !== undefined) {
            const formData = new FormData();
            formData.append('files', fileObject.data.file);

            const model = {
                tipoArchivo: TAS_CLI,
                idExpediente
            };

            formData.append(
                'model',
                new Blob([
                    JSON.stringify(model)
                ], {
                        type: 'application/json'
                    })
            );

            const requestData = { query: formData };
            const documentType = model.tipoArchivo;

            return APIPost({
                dispatch,
                endpoint: 'mortgageRequesWorkDataFileMultipleSubmit',
                params: requestData,
                contentType: false
            })
                .then(response => {
                    recordProcess(PROC_ADD_PROPERTY_VALUE, PROC_END);

                    if (sendResponse) {
                        dispatch(appraisalPaymentSave(response, documentType));
                    } else {
                        dispatch(requestUploadSuccess(response));
                    }
                })
                .catch(response => {
                    if (!!response.error) {
                        recordProcess(PROC_ADD_PROPERTY_VALUE, PROC_FAIL);
                        dispatch(requestUploadFailure(response.error))
                    } else {
                        throw response;
                    }
                });
        }
    } else {
        return Promise.resolve();
    }
};

const updateCertDocuments = sendResponse => (dispatch, getState) => {

    const currentState = getState().mortgageRequestPropertyValue;
    const isAlreadyFetching = currentState.get('isFetchingCert');
    const idExpediente = getState().mortgageRequestState.get('idExpediente');

    if (!isAlreadyFetching) {
        dispatch(requestUploadCertInProgress());

        const fileObject = currentState.getIn(['files', 'fileCertificado']);

        if (fileObject !== undefined) {
            const formData = new FormData();
            formData.append('files', fileObject.data.file);

            const model = {
                tipoArchivo: TAS_CERT,
                idExpediente
            };

            formData.append(
                'model',
                new Blob([
                    JSON.stringify(model)
                ], {
                        type: 'application/json'
                    })
            );

            const requestData = { query: formData };
            const documentType = model.tipoArchivo;

            return APIPost({
                dispatch,
                endpoint: 'mortgageRequesWorkDataFileMultipleSubmit',
                params: requestData,
                contentType: false
            })
                .then(response => {
                    recordProcess(PROC_ADD_PROPERTY_CERT, PROC_END);

                    if (sendResponse) {
                        dispatch(appraisalPaymentSave(response, documentType));
                    } else {
                        dispatch(requestUploadCertSuccess(response));
                    }
                })
                .catch(response => {
                    if (!!response.error) {
                        recordProcess(PROC_ADD_PROPERTY_CERT, PROC_FAIL);
                        dispatch(requestUploadCertFailure(response.error))
                    } else {
                        throw response;
                    }
                });
        }
    } else {
        return Promise.resolve();
    }
};

const addFile = file => ({
    type: actionTypes.MORTGAGE_REQUEST_PROPERTY_VALUE_ADD_FILE,
    payload: file
});

module.exports = {
    updateDocuments,
    updateCertDocuments,
    addFile,
    resetView
};
